<template lang="pug">
div.slot-table__item 
  .slot-table__cell.slot-table__cell_time {{ item.timeHour }}
  .slot-table__cell
    v-chip(small color="amber lighten-1").text-bold.white--text {{ item.productName }}
  .slot-table__cell.slot-table__cell_quant
    b {{ item.quantity }}
  .slot-table__cell
    span {{ cbrAccount }}


</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },

  computed: {
    cbrAccount() {
      return this.$store.getters['cbrUser/getNameByID'](this.item.cbrUser)
    }
  }
}
</script>